import type { CalendarSubscriptionState } from "@/lib/api/calendarSubscription";

const day = (iso: string) => new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" });

/** The word for the address, never a chip or a countdown (LANGUAGE section 4). */
export function subscriptionWord(state: CalendarSubscriptionState | undefined): string {
  if (state?.state === "active" && state.created_at) return `Added ${day(state.created_at)}`;
  if (state?.state === "stopped" && state.revoked_at) return `Stopped ${day(state.revoked_at)}`;
  return "Not added";
}

export const CALENDAR_COPY = {
  label: "Your calendar",
  add: "Add to my calendar",
  job: "Subscribe a calendar app to this course's sessions, replace the address, or stop sharing it.",
  detail: "Your sessions for this course, as a calendar you subscribe to.",
  updates: "It updates on your calendar app's own schedule, usually within a day.",
  failed: "Your calendar address could not be checked.",
  stale: "Couldn't check again. This is the last answer.",
  seat: "A calendar address is not available for your seat on this course.",
  address: "Calendar address",
  shownOnce: "Shown once. Create a new address if you lose it.",
  inApp: "In your calendar app",
  copy: "Copy address",
  copied: "Address copied.",
  selectToCopy: "Select the address and copy it.",
  toCreate: "Create an address, then paste it into your calendar app. It is shown once.",
  choice: "This address",
  manage: "Change the address",
  lost: "The address was shown once, when you created it. Use New address if you lost it.",
  replace: "New address",
  replaceNote: "The earlier address stops working.",
  stop: "Stop sharing",
  stopNote: "Your calendar app keeps the sessions it already has.",
  choose: "Choose New address or Stop sharing.",
  verbs: { create: "Create address", replace: "Create a new address", stop: "Stop sharing this address" },
  caps: { create: "When you create the address", replace: "When you replace the address", stop: "When you stop sharing" },
  effects: {
    create: ["IMAM makes an address for your sessions in this course.", "It is shown once, here."],
    replace: ["A new address replaces this one, shown once, here.", "The earlier address no longer works."],
    stop: ["The address stops working.", "Your calendar app keeps the sessions it already has. Remove the calendar there to clear them."],
  },
  done: {
    create: "Your address is above. Copy it into your calendar app.",
    replace: "The earlier address no longer works.",
    stop: "Sharing stopped. Your calendar app keeps the sessions it already has. Remove the calendar there to clear them.",
  },
  refused: "Not done",
  unknown: "Not confirmed",
  unknownSentence: "The answer was lost, so it may have happened. Check reads what IMAM holds now.",
  check: "Check",
  checkNote: "Reads the address's state again. Nothing is created or stopped twice.",
  lostAddress: "The address itself didn't arrive. Use New address to get one you can copy.",
} as const;
